<template>
<div>
    <data-view v-on:delete-data="deleteData" v-for="data in dataList" :data.sync="data" v-bind:key="data.key"></data-view>
</div>
</template>

<script>
import DataView from '../Staff/DataView';
import axios from 'axios'
import { ToastProgrammatic as Toast } from 'buefy'

export default {
    data() {
        return {
            input: {
                level: '',
                name: '',
            },
            result: "",
            errors: []
        };
    },
    props: ['dataList'],
    components: {
        DataView,
    },
    methods: {
        deleteData(data) {
            if (confirm('Are you sure? ' + data.firstName + ' ' + data.lastName + ' will be permanently deleted!')) {
                this.input.email = localStorage.getItem('email')
                this.input.sessionID = localStorage.getItem('sessionID')
                this.input.dataID = data._id

                const dataIndex = this.dataList.indexOf(data);
                this.dataList.splice(dataIndex, 1);

                axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
                axios.defaults.responseType = 'json'
                axios.post(process.env.MY_URL + '/api/teachers/remove', this.input)
                    .then(response => {
                        console.log("imini 41")
                        console.log(response)

                        Toast.open({
                            color: 'is-dark', //is-white, is-black, is-light, is-dark, is-primary, is-info, is-success, is-warning, is-danger
                            message: 'Teacher successfully removed!',
                            type: 'is-success',
                            duration: 3000
                        })
                        // this.$router.push({
                        //     name: 'secure'
                        // })
                    })
                    .catch(e => {
                        console.log(e.response)
                        if (e.response.status === 401) {
                            console.log("salah login")
                            this.errors.push("Invalid login")
                            alert("Unauthorized access. Please re-login.")
                        } else {
                            this.errors.push(e)
                        }
                    })
            }
        },
        
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Staff/DataList.vue